import { render, staticRenderFns } from "./MailVariablePicker.vue?vue&type=template&id=4cabac44&scoped=true&"
import script from "./MailVariablePicker.vue?vue&type=script&lang=js&"
export * from "./MailVariablePicker.vue?vue&type=script&lang=js&"
import style0 from "./MailVariablePicker.vue?vue&type=style&index=0&id=4cabac44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cabac44",
  null
  
)

export default component.exports